import { Divider, Grid } from '@mui/material';
import ChatMessageAlterMessageTypeActions from './components/ChatMessageAlterMessageTypeActions/ChatMessageAlterMessageTypeActions';
import ChatMessagesContent from './components/ChatMessageContent/ChatMessagesContent';
import ChatMessagesHeader from './components/ChatMessagesHeader/ChatMessagesHeader';

const ChatMessageView = () => {
  return (
    <Grid container>
      <Grid size={12}>
        <ChatMessagesHeader />
      </Grid>
      <Grid size={12}>
        <ChatMessageAlterMessageTypeActions />
      </Grid>
      <Grid size={12}>
        <Divider />
      </Grid>
      <Grid size={12}>
        <ChatMessagesContent />
      </Grid>
    </Grid>
  );
};

export default ChatMessageView;
